export type Font = {
    primary?: number[];
    secondary?: {
        regular: number;
        bold: number;
    };
    type: 'sans-serif' | 'serif';
};

export const fontList: Record<string, Font> = {
    Arvo: {
        primary: [700],
        secondary: {
            regular: 400,
            bold: 700,
        },
        type: 'sans-serif',
    },
    Barlow: {
        primary: [700],
        secondary: {
            regular: 400,
            bold: 700,
        },
        type: 'sans-serif',
    },
    BirthstoneBounce: {
        primary: [400],
        type: 'sans-serif',
    },
    Calistoga: {
        primary: [400],
        type: 'serif',
    },
    Courgette: {
        primary: [400],
        type: 'sans-serif',
    },
    CourierPrime: {
        primary: [700],
        secondary: {
            regular: 400,
            bold: 700,
        },
        type: 'serif',
    },
    CrimsonPro: {
        primary: [300],
        secondary: {
            regular: 400,
            bold: 700,
        },
        type: 'serif',
    },
    DancingScript: {
        primary: [700],
        type: 'sans-serif',
    },
    DMSans: {
        primary: [700],
        secondary: {
            regular: 400,
            bold: 700,
        },
        type: 'sans-serif',
    },
    Lora: {
        primary: [600],
        secondary: {
            regular: 400,
            bold: 700,
        },
        type: 'serif',
    },
    LibreBaskerville: {
        primary: [700],
        secondary: {
            regular: 400,
            bold: 700,
        },
        type: 'serif',
    },
    MsMadi: {
        primary: [400],
        type: 'sans-serif',
    },
    Inter: {
        primary: [700],
        secondary: {
            regular: 400,
            bold: 700,
        },
        type: 'sans-serif',
    },
    OrelegaOne: {
        primary: [400],
        type: 'serif',
    },
    PlayfairDisplay: {
        primary: [600],
        type: 'serif',
    },
    Poppins: {
        primary: [600],
        secondary: {
            regular: 400,
            bold: 700,
        },
        type: 'sans-serif',
    },
    Quicksand: {
        primary: [700],
        secondary: {
            regular: 500,
            bold: 700,
        },
        type: 'sans-serif',
    },
    RobotoSlab: {
        primary: [800],
        secondary: {
            regular: 300,
            bold: 800,
        },
        type: 'serif',
    },
    BebasNeue: {
        primary: [400],
        type: 'sans-serif',
    },
    PermanentMarker: {
        primary: [400],
        type: 'sans-serif',
    },
    Podkova: {
        primary: [600],
        secondary: {
            regular: 400,
            bold: 600,
        },
        type: 'serif',
    },
    ClashGrotesk: {
        secondary: {
            regular: 400,
            bold: 600,
        },
        type: 'sans-serif',
    },
    RubikMonoOne: {
        primary: [400],
        type: 'sans-serif',
    },
    Rubik: {
        secondary: {
            regular: 300,
            bold: 700,
        },
        type: 'sans-serif',
    },
    Literata: {
        primary: [300],
        secondary: {
            regular: 300,
            bold: 700,
        },
        type: 'serif',
    },
};
